export default "__VITE_ASSET__CfIOdFiC__"